import { FC } from "react";
import { IonNote } from "@ionic/react";
import { AllieNoteProps } from "./Note.types";

export const AllieNote: FC<AllieNoteProps> = (props) => <IonNote {...props} />;
